<template>
<div class="record_box">
  <scroll
    :objData="newObj"
    :allLoaded="allLoaded"
    @pulldown="loadData"
    v-if="dataList.length > 0 && showPage"
  >
    <section class="data_list" v-for="(item,key) in newObj" :key="key">
      <p class="list_title border-bottom">{{key|timeType}}</p>
      <section class="list_item border-bottom" v-for="val in item" :key="val.id" @click="toDetail(val)">
        <section class="list_item_left">
          <p>月租缴费</p>
          <span>{{val.paySuccessAt}}</span>
        </section>
        <section class="list_item_right">
          <p>{{val.payAmount|priceFormat}}</p>
        </section>
      </section>
    </section>
  </scroll>
  <no-message v-if="dataList.length<=0 && showPage"></no-message>
</div>
</template>

<script>
import util from '../../utils/util';
import Scroll from "../../components/scroll";
import {loadParkHeaderById} from '../../utils/api';
import {mapState} from 'vuex';
import storage from '../../utils/storage';
import NoMessage from "../../components/nomessage";
 import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'
export default {
  name: 'parkingPayRecord',
  props: {},
  components: {
    Scroll,
    NoMessage
  },
  filters: {
    timeType(val){
      let {year,month} = util.formatTime(new Date(),17);
      if(val.slice(0,4) == year && val.slice(5,7)==month){
        return '本月'
      }else {
        return val
      }
    }
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data() {
    return {
      dataList:[],
      newObj:{},
      allLoaded:true,
      pullup:false,
      showPage:false
    }
  },
  created() {
    this.queryHistoryBill()
  },
  mounted(){
  },
  methods: {
    // 下拉刷新
    loadData() {
      this.pageNo = 1;
      util.showLoading();
      this.queryHistoryBill();
    },
    queryHistoryBill(){
      util.showLoading()
      let params = {
        id:this.$route.query.id,
        url:"/parking/rstParkLot/queryHistoryBill"
      }
      loadParkHeaderById(params).then(res=>{
        util.hideLoading()
        console.log(res)
        this.showPage = true;
        if(res.res.code === 10000 && res.body && res.body.data){
          let dataList = res.body.data.data || [];
          this.dataList = dataList;
          console.log(this.dataList)
          let obj = {};
          dataList.forEach(item=>{
            let date = util.formatTime(new Date(item.paySuccessAt.replace(/\./g,'/')),18);
            if(!obj[date]){
              obj[date] = [item]
            }else{
              obj[date] = [...obj[date],item]
            }
          })
          this.newObj = obj
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    toDetail(item){
      storage.set('recordItem',JSON.stringify(item))
      this.$router.push(`/paymentRecordDetail`)
    }
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/common.less";
.record_box{
  background:#eee;
  height:100vh;
  .data_list{
    background:#fff;
    margin:20px 20px 0;
    border-radius: 8px;
    overflow: hidden;
    .list_title{
      height:88px;
      line-height:88px;
      background:rgba(252,252,252,1);
      box-shadow:0px 4px 8px 0px rgba(0,0,0,0.02);
      padding-left:48px;
      position: relative;
      &:after{
        position: absolute;
        left:28px;top:32px;
        content:'';
        width:6px;
        height:24px;
        background:#1740da;
      }
    }
    .list_item{
      .flex();
      justify-content: space-between;
      align-items: center;
      padding:22px 28px;
      .list_item_left{
        .flex(column);
        p{
          height:40px;
          font-size:28px;
          color:rgba(51,51,51,1);
          line-height:40px;
          margin-bottom:8px;
        }
        span{
          height:28px;
          font-size:24px;
          color:rgba(153,153,153,1);
          line-height:28px;
        }
      }
      .list_item_right{
        p{
          font-size:32px;
          font-weight:bold;
          color:rgba(51,51,51,1);
        }
      }
    }
  }
}
</style>
